import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import MasterData from '../../data/MasterData'
import QueryString from 'query-string'
import { tidTrainKindClass } from '../../utils/ClassHelper'

const TrainSelectModal = ({ themeName, closeTrainSelectModal, selectingTrains }) => {
  const navigate = useNavigate()

  useEffect(() => {
    if (selectingTrains.length == 0) {
      navigate(-1)
    }

    return () => {
      closeTrainSelectModal()
    }
  }, [])

  const handleCloseClick = (e) => {
    navigate(-1)
  }

  const handleTrainClick = (train) => {
    navigate(`/lines/for_tokyu/trains/${train.train_number}`, { replace: true })
  }

  const renderTrains = () => {
    return (
      <ul>
        {
          selectingTrains.map(train => {
            const destinationStation = MasterData.stationByTokyuDestinationCode(train.destination_station_code)
            return (
              <li className="d-TrainSelectModal-item" key={train.train_number}>
                <a onClick={() => handleTrainClick(train)} className="d-TrainSelectModal-itemLink">
                  <span className={`c-Label d-TrainSelectModal-label d-TrainSelectModal-colorItem ${tidTrainKindClass(train)}`}>
                    {MasterData.trainKindById(train.train_kind_id).name_ja}
                  </span>
                  <p className="d-TrainSelectModal-stationName">
                    {destinationStation ? destinationStation.name : ''}
                  </p>
                </a>
              </li>
            )
          })
        }
      </ul>
    )
  }
  
  return (
    <div className="c-Modal">
      <div className="c-Modal-dialog">
        <div className="c-Modal-header is_default">
          <p className="c-Modal-headerTitle">
            <span>列車情報</span>
          </p>
          <div className="c-Modal-headerClose" onClick={handleCloseClick}></div>
        </div>

        {renderTrains()}
      </div>
    </div>
  )
}

TrainSelectModal.propTypes = {
  themeName: PropTypes.string.isRequired,
  closeTrainSelectModal: PropTypes.func.isRequired,
  selectingTrains: PropTypes.array.isRequired,
}

export default TrainSelectModal
